import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29.75 26l-12-22a2 2 0 00-3.52 0l-12 22A2 2 0 004 29h24a2 2 0 001.75-3zM4 27L16 5l12 22z"/><path d="M16 22.5a1.49 1.49 0 00-1.5 1.5 1.5 1.5 0 001.5 1.5 1.49 1.49 0 001.5-1.5 1.48 1.48 0 00-1.5-1.5zM16 11a1.68 1.68 0 00-1.74 1.79l.69 6.4a1.09 1.09 0 002.11 0l.68-6.4A1.67 1.67 0 0016 11z"/>';
export var WarningOutlineSVG = function WarningOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
WarningOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(WarningOutlineSVG);